export const FROM_FOUR_TO_FIVE = [
    'Діти у цьому віці вибирають улюблений одяг, відмовляються надягати на себе хоч і теплі,' +
    ' але негарні на їх погляд чи незручні речі. Вибирайте одяг разом з дитиною, щоб він був не' +
    ' тільки практичним, зручним, комфортним, але й улюбленим.'
];

export const FROM_FOUR_TO_FIVE_HOT = 'Одягнути дитину в теплу і жарку пору року просто: одягаємо улюблений зручний одяг,' +
    ' головне, щоб він був із приємних для тіла тканин.';

export const FROM_FOUR_TO_FIVE_COLD = [
    'Одягнути у міжсезоння та холоди складніше.Краще за низької температури дотримуватися принципу багатошаровості: ',
    ' спочатку одягають білизну, бавовняну, комфортну;',
    ' якщо є можливість – одягають термобілизну (футболку з довгим рукавом та штанці),' +
    ' термобілизна добре відводить вологу' +
    ' та зайве тепло від тіла, дозволяючи шкірі дихати;',
    ' якщо немає термобілизни - одягають тонку водолазку з довгим рукавом;',
    ' поверх одягають щільну теплу кофту з довгим рукавом та високим коміром, теплі колготки;',
    ' останній шар – демісезонний або зимовий комплект верхнього одягу.'
];

export const SIX_AGE = [
    'Заохочуйте самостійність дитини, кажіть, яка погода, нехай вона сама скаже, що одягають за такої температури,' +
    ' а ви її виправите, якщо потрібно. Одяг вибирайте з дитиною.'
];